import { useTranslation } from 'react-i18next'

import { QA_NAME_CREATE_BTN } from '../../../../constants/qa'
import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import { FormModal } from '../../../Form'

import {
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_INITIAL_VALUES,
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_QA_NAME,
} from './RequestProfileTabActivitiesAddPhaseModal.constants'
import {
  getRequestProfileTabActivitiesAddPhaseModalPayload,
  getRequestProfileTabActivitiesAddPhaseModalValidationSchema,
} from './RequestProfileTabActivitiesAddPhaseModal.utils'
import { RequestProfileTabActivitiesAddPhaseModalFields } from './RequestProfileTabActivitiesAddPhaseModalFields'

function RequestProfileTabActivitiesAddPhaseModal({
  pipelineId,
  position,
  onClose,
  onSubmit,
  onSuccess,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const validationSchema =
    getRequestProfileTabActivitiesAddPhaseModalValidationSchema(t)

  function handleSubmit({ setErrors, setSubmitting, values }) {
    onSubmit(
      getRequestProfileTabActivitiesAddPhaseModalPayload({
        pipelineId,
        position,
        values,
      })
    )
      .then(({ data }) => onSuccess(data))
      .catch(({ response }) => {
        setSubmitting(false)

        if (response?.data) {
          setErrors(parseServerValidation(response.data))
        } else {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        }
      })
  }

  return (
    <FormModal
      Fields={RequestProfileTabActivitiesAddPhaseModalFields}
      containerProps={{
        qaName: REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_QA_NAME,
      }}
      formBodyProps={{
        submitButtonText: 'Modal.CreateBtnKey',
        submitQaName: QA_NAME_CREATE_BTN,
        withNotifications: true,
      }}
      formTitle='Modal.RequestProfileTabActivitiesAddPhaseTitleKey'
      initialValues={
        REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_INITIAL_VALUES
      }
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestProfileTabActivitiesAddPhaseModal
